/* ============================================================================
   SUNNY STRIPES — ACREAGE ON THE BIG-LOT CARDS                  added 2026-10-09
   ----------------------------------------------------------------------------
   THERE ARE NO PRICES IN THIS FILE.

   THE PROBLEM IT FIXES
   The "1/2 - 1 acre" and "1 - 3 acres" size cards said "Priced per acre", but a
   card has no acreage to price - sunny-quote-v19.js priced every 1-3 acre lawn
   at 2 acres and every 1/2-1 acre lawn at 0.75. A 1.1-acre and a 2.9-acre yard
   got the same quote. Carl caught it on 2026-10-09.

   WHAT IT DOES
   Picking either card opens a small "How many acres of lawn?" box under the
   cards, prefilled with the acreage the card used to assume, so a price shows
   straight away and the customer can see exactly what it is based on. Typing
   their own figure re-prices everything on the page at that exact size.

   It works through v19's own exact-size mechanism, not around it. The "I know
   my sq ft" and satellite paths already set S.lot (the band) and S.acres (the
   exact size), and v19 prices off S.acres when it is set - so this does the
   same thing. Two consequences come for free:
     - the lead email's lot size reads "1.40 acres" rather than a band name,
       because v19's lotLabel() prints S.acres for acreage cards;
     - typing more than 3 acres moves the customer onto the "3+ acres" custom
       quote, and under half an acre onto the right smaller card, exactly as the
       square-footage box does.

   CHECKOUT. An exact-size price can differ from the size-band product the cart
   would charge. assets/ss-book-now.js holds back any line where it does - see
   EXACT-SIZE QUOTES there. Do not remove one of these without the other.

   Loaded by snippets/instant-quote-pricing.liquid after ss-instant-quote-rates.js
   and before ss-book-now.js. Uses its own ids (ssAcre*) and no Dawn class names
   (.field/.grid/.badge), so the theme's global styles cannot draw boxes on it.
   ============================================================================ */
(function () {
  "use strict";

  var ACRE_CARDS = { a1: true, a3: true };
  var HINT = "Enter your acreage";
  var BOX_ID = "ssAcre";

  /* True once the customer has typed into the box since last picking a card,
     so the box stays open if their figure moved them onto a different card. */
  var typed = false;

  function ready() {
    return typeof S !== "undefined" && S && typeof CONFIG !== "undefined" &&
           CONFIG.lots && typeof window.calc === "function" &&
           document.getElementById("lots");
  }

  function lot(id) {
    for (var i = 0; i < CONFIG.lots.length; i++) if (CONFIG.lots[i].id === id) return CONFIG.lots[i];
    return null;
  }

  function cardsMode() { return !S.sizeMode || S.sizeMode === "cards"; }

  function fmt(a) { return (Math.round(a * 100) / 100).toString(); }

  /* "1 acre", "1.4 acres" */
  function acres(a) { return fmt(a) + (fmt(a) === "1" ? " acre" : " acres"); }

  function styles() {
    if (document.getElementById(BOX_ID + "Css")) return;
    var s = document.createElement("style");
    s.id = BOX_ID + "Css";
    /* !important on spacing because the quote tool zeroes padding and margin on
       everything inside it - same reason as the Book Now panel. */
    var P = "#" + BOX_ID;
    s.textContent =
      P + "{margin:12px 0 0 !important;padding:16px 18px !important;border:1.5px solid #A0C537;" +
      "border-radius:12px;background:#F6F4EC;font-family:'Assistant',Helvetica,Arial,sans-serif}" +
      P + " label{display:block;font-size:14.5px;font-weight:800;color:#235029;" +
      "margin:0 0 8px !important;padding:0 !important}" +
      P + " .ssAcreRow{display:flex;align-items:center;gap:10px;margin:0 !important;padding:0 !important}" +
      P + " input{width:110px !important;max-width:110px !important;flex:0 0 auto !important;" +
      "font:inherit;font-size:16px;font-weight:700;color:#22331F;" +
      "border:1.5px solid #CFD8BF !important;border-radius:9px !important;background:#fff;" +
      "margin:0 !important;padding:9px 12px !important}" +
      P + " input:focus{outline:2px solid #A0C537;outline-offset:1px}" +
      P + " .ssAcreUnit{font-size:14.5px;color:#22331F}" +
      P + " .ssAcreRead{font-size:13px;line-height:1.55;color:#5F7060;" +
      "margin:9px 0 0 !important;padding:0 !important}" +
      P + " .ssAcreRead b{color:#235029}";
    document.head.appendChild(s);
  }

  function box() {
    var el = document.getElementById(BOX_ID);
    if (el) return el;
    var lots = document.getElementById("lots");
    el = document.createElement("div");
    el.id = BOX_ID;
    el.style.display = "none";
    el.innerHTML =
      '<label for="ssAcreIn">How many acres of lawn?</label>' +
      '<div class="ssAcreRow"><input id="ssAcreIn" type="number" inputmode="decimal" ' +
      'min="0.1" max="20" step="0.1"><span class="ssAcreUnit">acres</span></div>' +
      '<p class="ssAcreRead" id="ssAcreRead"></p>';
    lots.parentNode.insertBefore(el, lots.nextSibling);
    document.getElementById("ssAcreIn").addEventListener("input", onType);
    return el;
  }

  /* The customer typed an acreage. Pick the band it falls in, mark that card,
     and price at the exact figure.

     WHICH CARD A ROUND NUMBER LANDS ON - Carl's call 2026-10-09. v19's own
     card limits are inclusive at the top, which put exactly 1 acre on the
     "1/2 - 1 acre" card and exactly 1/2 acre on "Extra Large". A one-acre lot is
     a different job from a half-acre one, so a round acreage belongs to the
     card it STARTS: 1/2 acre -> "1/2 - 1 acre", 1 acre -> "1 - 3 acres". The one
     exception is the top: "1 - 3 acres" keeps exactly 3, because the card says
     so, and only past 3 does it become a custom quote. The price was exact
     either way; this decides the card shown and the size band booked. */
  function onType(e) {
    var v = parseFloat(e.target.value);
    if (!(v > 0)) return;
    typed = true;
    var sqft = v * 43560, chosen = null, i, L, inBand;
    for (i = 0; i < CONFIG.lots.length; i++) {
      L = CONFIG.lots[i];
      inBand = L.id === "a3" ? sqft <= L.max + 1 : sqft < L.max - 1;
      if (inBand) { chosen = L; break; }
    }
    if (!chosen) chosen = CONFIG.lots[CONFIG.lots.length - 1];
    S.lot = chosen.id;
    S.acres = v;
    var cards = document.getElementById("lots").children;
    for (i = 0; i < cards.length; i++) cards[i].classList.toggle("sel", cards[i].dataset.id === chosen.id);
    window.calc();
  }

  /* Runs after every recalculation: show, hide and word the box to match. */
  function sync() {
    var el = box();
    var L = S.lot ? lot(S.lot) : null;
    var onAcreCard = !!(L && ACRE_CARDS[L.id]);
    if (!cardsMode() || !L || (!onAcreCard && !(typed && S.acres != null))) {
      el.style.display = "none";
      if (!onAcreCard) typed = false;
      return;
    }
    el.style.display = "";
    var inp = document.getElementById("ssAcreIn");
    var read = document.getElementById("ssAcreRead");

    if (S.acres == null) {
      /* Card just picked: show what the card prices at, and say so. */
      typed = false;
      if (document.activeElement !== inp) inp.value = fmt(L.acres);
      read.innerHTML = "Priced at <b>" + acres(L.acres) + "</b> for now. Change it to " +
                       "your lawn's acreage for an exact price. Not sure? Use " +
                       "<b>Measure from satellite</b> above.";
      return;
    }
    if (L.custom) {
      read.innerHTML = "<b>" + acres(S.acres) + "</b> is a big parcel, so we'll walk it " +
                       "and put a custom price in writing.";
    } else if (!ACRE_CARDS[L.id]) {
      read.innerHTML = "<b>" + acres(S.acres) + "</b> puts you on the " + L.nm + " card, " +
                       "priced at your exact size.";
    } else {
      read.innerHTML = "Priced at <b>" + acres(S.acres) + "</b>, your exact size. " +
                       "We confirm it when we see the property.";
    }
  }

  function hook() {
    /* The cards' hint line, which used to promise "Priced per acre". */
    var changed = false;
    for (var id in ACRE_CARDS) {
      var L = lot(id);
      if (L && L.hint !== HINT) { L.hint = HINT; L.chint = HINT; changed = true; }
    }
    if (changed && typeof window.renderLots === "function") {
      try { window.renderLots(); } catch (e) {}
    }
    if (window.calc.__ssAcreWrapped) return;
    var orig = window.calc;
    var wrapped = function () {
      var r = orig.apply(this, arguments);
      try { sync(); } catch (e) {}
      return r;
    };
    wrapped.__ssAcreWrapped = true;
    window.calc = wrapped;
  }

  var tries = 0;
  var t = setInterval(function () {
    if (ready()) {
      clearInterval(t);
      styles();
      hook();
      try { sync(); } catch (e) {}
      return;
    }
    if (++tries > 80) clearInterval(t);
  }, 50);
})();